import React, { Component, useState, useEffect } from "react";
import { hot } from "react-hot-loader";
import { Form, Input, Button, notification, message, Spin } from "antd";
import { connect } from "dva";
import { default as common, delay, handleError } from "../../utils/common";
import TestSuiteInput from "../TestCaseAdd/TestSuiteInput";
import * as tc from "../../services/tc";
import TCRichTextEditorv2 from "../common/TCRichTextEditorv2";
import { AppContext } from "../../AppContext";
import { SuitesApi } from "../../services/generated-sdk";
import { hasPermission } from "../Roles/common";
const { TextArea } = Input;

class AddSuiteFormStatic extends Component {
  static contextType = AppContext;
  componentDidMount() {
    if (this.context.setPageTitle) this.context.setPageTitle("Add Suite");
  }
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        //console.log("Received values of form: ", values);
        this.props.addSuite(values, () => {
          this.props.form.resetFields();
        });
      }
    });
  };

  saveAndAddAnother = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.addAnother = 1;
        this.props.addSuite(values, () => {
          this.props.form.resetFields();
        });
        this.props.form.resetFields(["title", "description"]);
        //@todo - reset parent suite selector - as not cleared by resetFields()
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className={this.props.isModal ? "" : "white_wrapper"}>
        <Form onSubmit={this.handleSubmit} layout="vertical">
          <Form.Item label="Title">
            {getFieldDecorator("title", {
              rules: [
                { required: true, message: "Please enter suite title" },
                {
                  whitespace: true,
                  message: "Title cannot be left blank"
                },
                {
                  max: 250,
                  message: "Title cannot be more than 250 characters"
                }
              ]
            })(<Input autoFocus placeholder="Title" />)}
          </Form.Item>

          <Form.Item label="Parent Suite " key="suite">
            {getFieldDecorator("suite_id", {
              placeholder: "Select Suite"
            })(<TestSuiteInput projectId={this.props.projectId} />)}
          </Form.Item>

          <Form.Item label="Description" key="description">
            {getFieldDecorator("description", {
              //rules: [{ required: true, message: "Please select parent suite" }]
            })(<TCRichTextEditorv2 company={this.props.company} />)}
          </Form.Item>

          <Form.Item>
            <center>
              <Button
                type="primary"
                // htmlType="submit"
                onClick={this.handleSubmit}
                loading={this.props.formLoading}
                className="btn-success"
              >
                Save Suite
              </Button>{" "}
              &nbsp;
              {this.props.hideAnother !== true ? (
                <Button
                  onClick={this.saveAndAddAnother}
                  loading={this.props.formLoading}
                >
                  Save & add another
                </Button>
              ) : null}{" "}
              &nbsp;
              {this.props.showCancel !== false ? (
                <Button
                  //type="danger"
                  onClick={() =>
                    this.props.history.push(
                      `/project/${this.props.projectId}/manage`
                    )
                  }
                  //loading={this.props.formLoading}
                  className="cancel"
                >
                  Cancel
                </Button>
              ) : null}
              &nbsp;
            </center>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export const AddSuiteForm = Form.create({})(AddSuiteFormStatic);

function AddSuiteStatic({
  params,
  history,
  isModal,
  hideModal,
  showCancel = true
}) {
  // console.log(" MMATCH ", props);
  const [formLoading, setformLoading] = useState(false);
  const [refreshForm, setRefreshForm] = useState(false);
  //const projectId = params.projectId;
  const { projectId, loggedInUser, company } = React.useContext(AppContext);
  useEffect(() => {
    const canAddSuite = hasPermission(loggedInUser, "suiteAdd");
    if (!canAddSuite) history.push(`/project/${projectId}/manage`);
  }, []);
  const addSuite = async (form, callback) => {
    setformLoading(true);
    //console.log("form posted", form);
    await delay(500);
    //setformLoading(false);
    //return;
    const API = new SuitesApi();
    try {
      const data = await API.addSuite({
        addSuitePayload: {
          title: form.title,
          parentId: form.suite_id != undefined ? form.suite_id : null,
          description: form.description != undefined ? form.description : "",
          project: projectId
        }
      });
      setformLoading(false);
      if (data && data.id && data.title == form.title.trim()) {
        notification["success"]({
          message: "Suite added!",
          description:
            form.addAnother != undefined
              ? "Form has been reset. Now you can add another suite"
              : ""
        });
        if (form.addAnother == undefined) {
          if (isModal === true) {
            hideModal();
          } else {
            history.push(`/project/${projectId}/manage`);
          }
          return;
        }
        if (form.addAnother) {
          if (!isModal) {
            //window.location.reload();
            setRefreshForm(true);
            await delay(500);
            setRefreshForm(false);
          }
        }
      } else {
        console.info("Failed to add suite");
        notification["error"]({
          message: "Error",
          description: data && data.title ? data.title : "Failed to add suite"
        });
      }
    } catch (e) {
      e.json().then(data => {
        handleError(data.statusCode, {}, data.message || "");
      });
    }
    setformLoading(false);
  };

  return (
    <div>
      {refreshForm ? (
        <Spin>Resetting form...</Spin>
      ) : (
        <AddSuiteForm
          formLoading={formLoading}
          addSuite={addSuite}
          projectId={projectId}
          history={history}
          showCancel={showCancel}
          company={company}
        />
      )}
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    projectId: state.app.projectId
  };
}

const AddSuite = connect(mapStateToProps)(AddSuiteStatic);

export default hot(module)(AddSuite);
